// removed by extract-text-webpack-plugin
module.exports = {"graphChart":"motive_graphChart_2ZGJn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/financialPicture/overview/subComponents/fraud/motive.scss
// module id = 1548
// module chunks = 0